<div class="overflow-hidden py-24 my-2 sm:py-32 rounded rounded-3">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
            <div class="lg:pr-8 lg:pt-4">
                <div class="lg:max-w-lg">
                    <h2 class="font-l leading-7  text-normal">{{componentModel.title.value}}</h2>
                    <p class="mt-2 text-3xl font-bold tracking-tight sm:text-4xl text-normal" >{{componentModel.subtitle.value}}</p>
                    <p class="mt-6 text-lg leading-8 text-normal" >{{componentModel.description.value}}</p>
                </div>
            </div>
            <div>
                @if(componentModel.videoUrl.value){
                    <video controls
                           defaultMuted
                           preload="auto"
                           class="relative w-full h-full object-cover">
                        <source [src]="componentModel.videoUrl.value" type="video/mp4">
                        Your browser does not support HTML5 video.
                    </video>
                }
            </div>
        </div>
    </div>
</div>

